import React, { useState, useRef, useCallback } from 'react';
import AiraContainer from '../UtilComponents/AiraContainer';
import LocaleHoc from '../../LocaleHoc';
import { AiraFAB, AiraRound } from '../UtilComponents/Icons';
import './_configurationBot.scss';
import CapRow from '../../CapRow';
import CapHeading from '../../CapHeading';
import offerIconSvg from '../../assets/images/offer.svg';
import cartIconSvg from '../../assets/images/cart.svg';
import CapImage from '../../CapImage';
import CapLabel from '../../CapLabel';
import IdentityIcon from './IdentityIcon';
import {
  MESSAGE_TYPES,
  IDENTITY_ICON_TYPES,
  MESSAGE_TYPE_INFERENCE,
  MESSAGE_TYPE_STATUS,
  MESSAGE_TYPE_TEXT,
  SERVER_URL,
  MESSAGE_TYPE_COPY,
} from './constants';
import { v4 as uuidv4 } from 'uuid';
import CopilotResponse from './CopilotResponse';
import UserRequest from './UserRequest';
import CapDivider from '../../CapDivider';
import GeneratingResponse from './GeneratingResponse';
import useWebsocket from '../hooks/useWebsocket';
import { rootClsPrefix } from '../constants';
import MultiLineInputBox from '../UtilComponents/MultiLineInpuxBox';

export const clsPrefix = 'cap-aira-config-bot';

const ConfigurationBot = ({
  iconPlacement,
  textAiraTitle,
  textAiraTooltip,
  ...rest
}) => {
  return (
    <>
      <AiraContainer
        titlePadding="0.5rem"
        popupWidth="45rem"
        Icon={AiraFAB}
        iconPlacement={iconPlacement}
        title={textAiraTitle}
        titleDescription={textAiraTooltip}
        titleBarIcon={AiraRound}
        popupHeight="100vh"
        popupPlacement={{ type: 'float-br', padding: '0rem' }}
      >
        <PopupContent {...rest} />
      </AiraContainer>
    </>
  );
};

const BootupPage = ({
  setQuery,
  textUser,
  textPilot,
  textCouponTile,
  textCouponDescription,
  textPromotionTitle,
  textPromotionDescription,
  textStreakTitle,
  textStreakDescription,
  textCouponPrompt,
  textPromotionPrompt,
  textStreakPrompt,
}) => {
  return (
    <div className="bootup-page-container">
      <CapRow className="bootup-page-r1">
        <IdentityIcon
          iconType={IDENTITY_ICON_TYPES.BOOTUP_PAGE_BOT}
          classPrefixName="boot-page-copilot-icon"
        />
        <CapHeading className="user-name-heading">{textUser}</CapHeading>
        <CapHeading className="user-description-heading">
          {textPilot}
        </CapHeading>
      </CapRow>

      <CapRow>
        <div className="coupon-promotion-container">
          <div style={{ width: 0, flexGrow: 1 }}>
            <CapRow
              data-testid="milestone-on-gs-template"
              onClick={() => setQuery(textCouponPrompt)}
            >
              <CapRow className="predefined-templates-container">
                <CapRow className="create-template-container">
                  <CapRow
                    type="flex"
                    className="create-template-title-container"
                  >
                    <CapImage src={offerIconSvg} />
                    <CapHeading
                      type="h4"
                      className="each-item-margin title-margin"
                    >
                      {textCouponTile}
                    </CapHeading>
                  </CapRow>

                  <CapLabel type="label31" className="each-item-margin">
                    {textCouponDescription}
                  </CapLabel>
                </CapRow>
              </CapRow>
            </CapRow>
          </div>
          <div style={{ width: 0, flexGrow: 1 }}>
            <CapRow
              data-testid="promotion-template"
              onClick={() => setQuery(textPromotionPrompt)}
            >
              <CapRow className="predefined-templates-container">
                <CapRow className="create-template-container">
                  <CapRow
                    type="flex"
                    className="create-template-title-container"
                  >
                    <CapImage src={cartIconSvg} />
                    <CapHeading
                      type="h4"
                      className="each-item-margin title-margin"
                    >
                      {textPromotionTitle}
                    </CapHeading>
                  </CapRow>
                  <CapLabel type="label31" className="each-item-margin">
                    {textPromotionDescription}
                  </CapLabel>
                </CapRow>
              </CapRow>
            </CapRow>
          </div>
        </div>
        <CapRow
          key="create-streak-container"
          className="question-container"
          data-testid="streak-prompt"
          onClick={() => setQuery(textStreakPrompt)}
        >
          <CapRow className="predefined-templates-container">
            <CapRow className="question-template-container">
              <CapRow type="flex" className="create-template-title-container">
                <CapImage src={cartIconSvg} />
                <CapHeading
                  type="h4"
                  className="each-item-margin create-streak-margin"
                >
                  {textStreakTitle}
                </CapHeading>
              </CapRow>
              <CapLabel type="label31" className="each-item-margin">
                {textStreakDescription}
              </CapLabel>
            </CapRow>
          </CapRow>
        </CapRow>
      </CapRow>
    </div>
  );
};

const PopupContent = ({
  request,
  getAPICallObject,
  textPromptHere,
  textCreate,
  textCancel,
  textGeneratingResponse,
  firstName,
  lastName,
  ...rest
}) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [changes, setChanges] = useState({});
  const [showBootupPage, setShowBootupPage] = useState(true);
  const [chat, setChat] = useState([]);
  const [progressStatusData, setProgressStatusData] = useState([]);

  const scrollRef = useRef();

  const scrollToBottomWithDelay = () => {
    setTimeout(() => {
      if (!scrollRef.current) return;
      const scrollGap =
        scrollRef.current.scrollHeight -
        (scrollRef.current.scrollTop + scrollRef.current.clientHeight);
      if (scrollGap > scrollRef.current.clientHeight) {
        return;
      }
      scrollRef.current.scroll(0, scrollRef.current.scrollHeight);
    }, 50);
  };

  const generateUniqueId = () => {
    return uuidv4();
  };

  const onMessage = useCallback(msgJson => {
    if (
      msgJson.type === MESSAGE_TYPE_TEXT ||
      msgJson.type === MESSAGE_TYPE_INFERENCE ||
      msgJson.type === MESSAGE_TYPE_COPY
    ) {
      setLoading(false);
      setProgressStatusData([]);
      addMessageToChat({
        messageType: MESSAGE_TYPES.COPILOT,
        data: msgJson,
      });
      scrollToBottomWithDelay();
    } else if (msgJson.type === MESSAGE_TYPE_STATUS) {
      setProgressStatusData(progressData => {
        return [...progressData, msgJson];
      });
      scrollToBottomWithDelay();
    }
  }, []);
  const onError = useCallback(() => {
    setLoading(false);
  }, []);
  let { sendMessage } = useWebsocket(SERVER_URL, onMessage, onError);
  const _sendMessage = sendMessage;
  sendMessage = msg => {
    setLoading(true);
    msg.changes = changes;
    _sendMessage(msg).then(() => {
      setChanges({});
    });
  };

  const addMessageToChat = ({ messageType, data }) => {
    setChat(chat => {
      return [
        ...chat,
        {
          messageType: messageType,
          data: data,
          id: generateUniqueId(),
        },
      ];
    });
  };
  const sendQuery = async message => {
    if (message) {
      sendMessage({
        type: MESSAGE_TYPE_TEXT,
        message: message,
      });

      addMessageToChat({
        messageType: MESSAGE_TYPES.HUMAN,
        data: { type: MESSAGE_TYPE_TEXT, message: message },
      });
    }
  };
  const handleSubmit = query => {
    if (loading || query.trim().length === 0) return;
    if (showBootupPage) {
      setShowBootupPage(false);
    }
    sendQuery(query);
    setQuery('');
    setLoading(true);
    scrollToBottomWithDelay();
  };

  const renderChatMessages = (chat, progressStatusData) => {
    const result = [];
    chat.forEach((message, index) => {
      const checkIfInference = message =>
        message?.messageType === MESSAGE_TYPES.COPILOT &&
        message?.data?.type === MESSAGE_TYPE_INFERENCE;
      let isLastInference = checkIfInference(chat[index]);
      for (let i = index + 1; i < chat.length; i++) {
        if (checkIfInference(chat[i])) {
          isLastInference = false;
          break;
        }
      }
      if (message?.messageType === MESSAGE_TYPES.HUMAN) {
        result.push(
          <CapRow
            className="each-response-display-container"
            key={message?.id}
            data-testid={index === 0 ? 'first-chat-message' : null}
          >
            <UserRequest
              message={message?.data?.message}
              firstName={firstName}
              lastName={lastName}
            />
          </CapRow>,
        );
      } else if (message?.messageType === MESSAGE_TYPES.COPILOT) {
        result.push(
          <CapRow className="each-response-display-container" key={message?.id}>
            <CopilotResponse
              changes={changes}
              setChanges={setChanges}
              request={request}
              getAPICallObject={getAPICallObject}
              loading={loading}
              message={message?.data}
              isLastInference={isLastInference}
              isLastMessage
              handleSubmit={handleSubmit}
              sendMessage={sendMessage}
              textCreate={textCreate}
              textCancel={textCancel}
            />
          </CapRow>,
        );
      }

      if (index < chat.length - 1) {
        result.push(
          <CapDivider
            className="gpt-response-divider"
            key={`${message?.id}-divider`}
          />,
        );
      }
    });

    if (chat?.length && loading) {
      result.push(
        <CapDivider
          className="gpt-response-divider"
          key="generate-response-divider"
        />,
      );

      result.push(
        <CapRow
          className="each-response-display-container"
          key="generate-response"
        >
          <GeneratingResponse
            textGeneratingResponse={textGeneratingResponse}
            progressStatusData={progressStatusData}
          />
        </CapRow>,
      );
    }

    return <CapRow className="chat-messages">{result}</CapRow>;
  };
  return (
    <div className={`${clsPrefix}-root`}>
      <div
        className={`${clsPrefix}-answer-container ${rootClsPrefix}-no-scrollbar`}
        ref={scrollRef}
      >
        {showBootupPage && <BootupPage setQuery={setQuery} {...rest} />}
        <CapRow className="copilot-body-container">
          {renderChatMessages(chat, progressStatusData)}
        </CapRow>
      </div>

      <MultiLineInputBox
        value={query}
        setValue={setQuery}
        placeholder={textPromptHere}
        onSubmit={() => handleSubmit(query)}
        loading={loading}
        style={{
          padding: '0 0.5rem 0.5rem 0.5rem',
        }}
      />
    </div>
  );
};

export default LocaleHoc(ConfigurationBot, {
  key: 'CapAskAira.ConfigurationBot',
});
